import { forwardRef, useId, type SVGAttributes } from 'react';

export interface IconProps extends SVGAttributes<SVGSVGElement> {
    color?: string;
    size?: string | number;
    title?: string;
}

const FileEarmarkPreview = forwardRef<SVGSVGElement, IconProps>(function FileEarmarkPreview(
    { color = 'currentColor', size = '1em', title = null, className = '', ...rest },
    ref,
) {
    const maskId = useId().replace(/:/g, '');
    const gradientId = useId().replace(/:/g, '');
    const gradientUrl = `url(#${gradientId})`;

    return (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width={size}
            height={size}
            className={['bi', 'bi-file-earmark-preview', className].filter(Boolean).join(' ')}
            {...rest}
        >
            {title ? <title>{title}</title> : null}
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="16" y2="16" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#EC4899" />
                    <stop offset="1" stopColor="#8B5CF6" />
                </linearGradient>
            </defs>
            <mask id={maskId}>
                <rect width="16" height="16" fill="#fff" />
                <circle cx="11.0" cy="11.3" r="3.35" fill="#000" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path fill={gradientUrl} d="M8.5 0H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 10 4.5h2V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                <path fill={gradientUrl} d="M4.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM4 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5" />
            </g>
            <circle cx="11.0" cy="11.3" r="2.8" fill="none" stroke={gradientUrl} strokeWidth="1.1" />
            <path d="M13.5 13.8L15.1 15.4" fill="none" stroke={gradientUrl} strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    );
});

export default FileEarmarkPreview;
export { FileEarmarkPreview };
